import { ComponentPropsWithoutRef, forwardRef } from "react"
import { SelectedFiltersT, TaxonomyT } from "./types"
import { tv, VariantProps } from "@utils/tw"
import { TICK } from "@components/atoms/Icons"

export const SortButtonWrapper = ({
  taxonomy,
  selectedFilters,
  setSelectedFilters,
}: {
  taxonomy: TaxonomyT
  selectedFilters?: SelectedFiltersT
  setSelectedFilters: React.Dispatch<React.SetStateAction<SelectedFiltersT>>
}) => {
  const selected = selectedFilters?.sort.slug === taxonomy.slug

  return (
    <li>
      <SortLabel selected={selected}>
        <button
          onClick={() =>
            setSelectedFilters((prevFilters) => ({
              ...prevFilters,
              sort: taxonomy,
            }))
          }
        >
          {TICK} <span>{taxonomy.name}</span>
        </button>
      </SortLabel>
    </li>
  )
}

const sortLabelStyles = tv({
  base: [
    "block w-full",
    "[&_button]:min-h-6 [&_button]:min-w-6",
    "[&_button]:!py-3 [&_button]:!pl-3 [&_button]:!pr-[calc(24px+var(--spacing-3))]",
    "[&_button]:type-label-s [&_button]:box-border [&_button]:!leading-[1.2]",
    "[&_button]:!rounded-[6px] [&_button]:cursor-pointer [&_button]:!flex [&_button]:items-center",
    "[&_button]:justify-start [&_button]:text-left [&_button]:no-underline",
    "[&_button]:transition-colors [&_button]:ease-movement [&_button]:duration-300",
    "[&_button]:bg-light-grey [&_button]:!text-black [&_button]:!border-none",
    "[&_button]:relative [&_button]:overflow-hidden",
    "[&_button:hover]:bg-grey [&_button:hover]:!text-black",
    "[&_button:active]:bg-black [&_button:active]:!text-white",
    "[&_button:disabled]:cursor-not-allowed [&_button:disabled]:bg-grey [&_button:disabled]:!text-mid-grey",
    "md:[&_button]:max-h-7",
    "[&_button_span]:transition-transform [&_button_span]:ease-movement [&_button_span]:duration-300",
    "[&_button_svg]:absolute [&_button_svg]:top-1/2 [&_button_svg]:mt-[-12px] [&_button_svg]:left-3",
    "[&_button_svg]:size-[24px] [&_button_svg]:!translate-x-[-24px] [&_button_svg]:opacity-0",
    "[&_button_svg]:transition-[transform,opacity] [&_button_svg]:ease-movement [&_button_svg]:duration-300",
  ],
  variants: {
    selected: {
      true: [
        "[&_button]:!bg-green-mid [&_button]:!text-green",
        "[&_button:hover]:!bg-green-mid [&_button:hover]:!text-green",
        "[&_button:active]:!bg-green-mid [&_button:active]:!text-green",
        "[&_button_svg]:!text-green [&_button_svg]:!translate-x-0 [&_button_svg]:opacity-100",
        "[&_button_span]:translate-x-[30px]",
      ],
    },
  },
})

const SortLabel = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<"div"> & VariantProps<typeof sortLabelStyles>
>(({ selected, className, ...props }, ref) => (
  <div ref={ref} className={sortLabelStyles({ selected, className })} {...props} />
))
SortLabel.displayName = "SortLabel"
